// Only the support chat uses this opener. All messages, including staff replies,
// are untrusted text; never turn HTML or Markdown into DOM content.
// These controls are deliberately forbidden in untrusted destinations.
// eslint-disable-next-line no-control-regex
const unsafeUrlCharacters = /[\u0000-\u0020\u007f-\u009f\u200b-\u200f\u202a-\u202e\u2060-\u206f\ufeff\\]/;

export function parseSupportUrl(value) {
  if (typeof value !== "string" || !/^https?:\/\//i.test(value)) return null;
  try {
    // Reject encoded control/bidi characters too, rather than hiding them in
    // the displayed destination. URL keeps international hosts in ASCII.
    if (
      unsafeUrlCharacters.test(value) ||
      unsafeUrlCharacters.test(decodeURIComponent(value))
    )
      return null;
    const url = new URL(value);
    if (
      !["http:", "https:"].includes(url.protocol) ||
      !url.hostname ||
      url.username ||
      url.password
    )
      return null;
    return { href: url.href, hostname: url.hostname };
  } catch (_) {
    return null;
  }
}

export function supportMessageParts(value) {
  return (typeof value === "string" ? value : "")
    .split(/(\s+)/)
    .filter(Boolean)
    .map(text => {
      const parsed = parseSupportUrl(text);
      return { text, url: parsed ? parsed.href : null };
    });
}

export function openSupportUrl(value, target = window) {
  const url = parseSupportUrl(value);
  if (!url) return false;
  if (
    target.location &&
    target.location.protocol === "chrome-extension:" &&
    target.chrome &&
    target.chrome.tabs
  ) {
    target.chrome.tabs.create({ url: url.href });
  } else if (target.cordova && target.cordova.InAppBrowser) {
    // System browser cannot receive a WebView opener reference.
    target.cordova.InAppBrowser.open(url.href, "_system", "location=yes");
  } else {
    target.open(url.href, "_blank", "noopener,noreferrer");
  }
  return true;
}
